import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions } from 'react-native';
import { Writing } from './writing.js';
import { Messages } from './messages.js';

const width = Dimensions.get('window').width;

export const ChatScreen = ({route}) => {

  return (
      <Layout style={styles.container} level='4' >
        <SafeAreaView>
        <Layout level='4' style={{ justifyContent: 'flex-end'}}>
        <Messages query={route.params.query} user={route.params.user}/>
        <Writing query={route.params.query}/>
        </Layout>
        </SafeAreaView>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    height: Dimensions.get('window').height,
  },
});
